import { t } from 'ttag'

import activitiesSvg from '@h2/assets/svg/blockGraphics/activities.svg'

import { Promotion } from '../../promotion'

const Activities = () => (
  <Promotion color="blue" variant="explorer">
    <Promotion.Heading>{t`Complete activities`}</Promotion.Heading>
    <Promotion.Text>{t`Use activities to learn more about yourself.`}</Promotion.Text>
    <Promotion.Button href="/assessments">{t`Start exploring`}</Promotion.Button>
    <Promotion.Image src={activitiesSvg} />
  </Promotion>
)

export { Activities }
